import { Injectable } from '@angular/core';
import { MensajeTemplate } from '../components/mensaje/mensaje.component';

@Injectable()
export class Utils {

  parseErrorMessage(err): string{
    const msg = err && err.description ? err.description : MensajeTemplate.ErrorGenerico;
    return msg;
  }

}
